module.exports = __webpack_public_path__ + "static/media/ApercuPro-LightItalic.a3fc228f.woff2";